import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import GetgeekFeedbackNavbar from "../components/GetgeekFeedbackNavbar";
import GetgeekFeedbackTable from "../components/GetgeekFeedbackTable";
const GetgeekFeedback = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  return (
    <div>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <GetgeekFeedbackNavbar />
      <GetgeekFeedbackTable />
    </div>
  );
};

export default GetgeekFeedback;
